// Make openCartDrawer and closeCartDrawer globally accessible
function openCartDrawer() {
  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) {
    cartDrawer.classList.remove("hidden"); // Remove the hidden class to show the cart drawer
    cartDrawer.classList.remove("hidden1"); // Remove any other hide class if used
  }
}

function closeCartDrawer() {
  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) {
    cartDrawer.classList.add("hidden1"); // Add a class to hide the cart drawer
  }
}

function refreshCartDrawerAndOpen() {
  // Adjust the URL if your section name is different
  fetch('/?section_id=cart-drawer')
    .then(response => response.text())
    .then(html => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      const newDrawer = tempDiv.querySelector('cart-drawer');
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && newDrawer) {
        cartDrawer.innerHTML = newDrawer.innerHTML;
      }
      openCartDrawer();
    });
}

function refreshCartPage() {
  // Adjust the URL if your section name is different
  fetch('/?section_id=main-cart-items')
    .then(response => response.text())
    .then(html => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      const newCartItems = tempDiv.querySelector('#main-cart-items');
      const cartItems = document.querySelector('#main-cart-items');
      if (cartItems && newCartItems) {
        cartItems.innerHTML = newCartItems.innerHTML;
      }
    })
    .catch(error => console.error("Error refreshing cart page:", error));
}

function refreshCartNotification() {
  // Adjust the URL if your section name is different
  fetch('/?section_id=cart-notification-product')
    .then(response => response.text())
    .then(html => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      const newNotification = tempDiv.querySelector('#cart-notification-product');
      const cartNotification = document.querySelector('#cart-notification-product');
      if (cartNotification && newNotification) {
        cartNotification.innerHTML = newNotification.innerHTML;
      }
    })
    .catch(error => console.error("Error refreshing cart notification:", error));
}

document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("special-instruction-modal");
  const overlay = modal.querySelector(".modal-overlay");
  const closeModalButton = modal.querySelector(".close-modal");
  const saveButton = modal.querySelector("#save-special-instruction");
  const removeButton = modal.querySelector("#remove-special-instruction");
  const heading = modal.querySelector("#special-instruction-heading");
  const textarea = modal.querySelector("#special-instruction-textarea-popup");

  let currentVariantId = null;
  let currentPropertyKey = null;

  // Event delegation for dynamically added "View" buttons
  document.body.addEventListener("click", (e) => {
    if (e.target.classList.contains("view-special-instruction")) {
      e.preventDefault();

      const button = e.target;
      currentVariantId = button.dataset.variantId;
      currentPropertyKey = button.dataset.propertyKey;
      const propertyValue = button.dataset.propertyValue;

      heading.textContent = currentPropertyKey;
      textarea.value = propertyValue;
      textarea.dataset.originalValue = propertyValue; // Store the original value

      closeCartDrawer(); // Close the cart drawer
      modal.classList.remove("hidden"); // Show the modal
    }
  });

  // Close Modal
  const closeModal = () => {
    modal.classList.add("hidden");
    currentVariantId = null;
    currentPropertyKey = null;
    openCartDrawer(); // Reopen the cart drawer when the modal is closed
  };

  closeModalButton.addEventListener("click", closeModal);
  overlay.addEventListener("click", closeModal);

  // Save Special Instruction
  saveButton.addEventListener("click", () => {
    const updatedValue = textarea.value;

    if (currentVariantId && currentPropertyKey) {
      // Fetch the current cart item properties
      fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {
          const cartItem = cart.items.find(
            (item) =>
              item.id == currentVariantId &&
              item.properties &&
              item.properties[currentPropertyKey] ===
                textarea.dataset.originalValue
          );

          if (!cartItem) {
            throw new Error("Cart item not found");
          }

          const line = cart.items.indexOf(cartItem) + 1; // Get the line number
          const existingProperties = cartItem.properties || {};

          // Merge existing properties with the updated special instruction
          const updatedProperties = {
            ...existingProperties,
            [currentPropertyKey]: updatedValue,
          };

          // Update the cart item with the merged properties and current quantity
          return fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              line: line, // Use the line number instead of id
              quantity: cartItem.quantity, // Always send current quantity!
              properties: updatedProperties,
            }),
          });
        })
        .then((response) => response.json())
        .then((data) => {
          closeModal();
          if (window.location.pathname === '/cart') {
            window.location.reload();
          } else {
            refreshCartDrawerAndOpen();
          }
        })
        .catch((error) => console.error("Error updating cart:", error));
    }
  });

  // Remove Special Instruction
  removeButton.addEventListener("click", () => {
    if (currentVariantId && currentPropertyKey) {
            if (currentPropertyKey === "Special instructions") {
        fetch("/cart.js")
          .then((response) => response.json())
          .then((cart) => {
            const cartItem = cart.items.find(
              (item) =>
                item.id == currentVariantId &&
                item.properties &&
                item.properties[currentPropertyKey] === textarea.dataset.originalValue
            );

            if (!cartItem) {
              throw new Error("Cart item not found");
            }

            const currentLine = cart.items.indexOf(cartItem) + 1;
            const savedQuantity = cartItem.quantity;

            // Step 1: Remove the current line item entirely
            return fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                line: currentLine,
                quantity: 0,
              }),
            })
              .then((res) => res.json())
              .then((updatedCart) => {
                // Step 2: In the fresh cart, find a same-variant item without "Special instructions"
                const targetItem = updatedCart.items.find(
                  (item) =>
                    item.id == currentVariantId &&
                    (!item.properties ||
                      !item.properties["Special instructions"] ||
                      item.properties["Special instructions"] === "")
                );

                if (targetItem) {
                  // Merge: add our quantity to the existing no-instruction item
                  const targetLine = updatedCart.items.indexOf(targetItem) + 1;
                  return fetch("/cart/change.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                      line: targetLine,
                      quantity: targetItem.quantity + savedQuantity,
                    }),
                  });
                } else {
                  // No existing no-instruction item — re-add clean
                  return fetch("/cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                      items: [{
                        id: parseInt(currentVariantId),
                        quantity: savedQuantity,
                      }],
                    }),
                  });
                }
              });
          })
          .then((response) => response.json())
          .then((data) => {
            closeModal();
            if (window.location.pathname === '/cart') {
              window.location.reload();
            } else {
              refreshCartDrawerAndOpen();
            }
          })
          .catch((error) =>
            console.error("Error removing special instruction:", error)
          );
      } else {
        console.warn("Only 'Special instructions' can be removed.");
      }
    }
  });
});